// extracted by mini-css-extract-plugin
export default {"content":"Apm5u","scrollable":"Iyjiw","bannerList1":"ZoLee","matchOfTheDay":"ECn2_","aviatorBanner":"LIycd"};